module.exports = __webpack_public_path__ + "static/media/Alpha-iQ-tm-RA-6500-iQ.b0207923.png";